export var mutations = {
    setCities: function (state, cities) {
        state.cities = cities;
    },
    setCitiesInUse: function (state, cities) {
        state.citiesInUse = cities;
    },
    setAppearance: function (state, appearance) {
        state.appearance = appearance;
    },
    setBranding: function (state, branding) {
        state.branding = branding;
    },
    setCompany: function (state, company) {
        state.company = company;
    },
    setLandingPage: function (state, landingPage) {
        state.landingPage = landingPage;
    },
    setEntityType: function (state, type) {
        state.entityType = type;
    },
    setError: function (state, error) {
        state.error = error;
    },
    setPrivacyPolicy: function (state, policyUrl) {
        state.privacyPolicy = policyUrl;
    },
};
export var types = {
    SET_CITIES: 'setCities',
    SET_CITIES_IN_USE: 'setCitiesInUse',
    SET_APPEARANCE: 'setAppearance',
    SET_BRANDING: 'setBranding',
    SET_COMPANY: 'setCompany',
    SET_LANDING_PAGE: 'setLandingPage',
    SET_ENTITY_TYPE: 'setEntityType',
    SET_ERROR: 'setError',
    SET_PRIVACY_POLICY: 'setPrivacyPolicy',
};
